<template>
  <div>
    <NuxtPage />
  </div>
</template>

<script>
export default defineComponent({
  name: 'FunBookOrderDetailPage',
})
</script>
